import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import React from 'react';
import { RowSectionType } from '../../../types/ancillaryCostTableRowTypes';

interface props {
  row: RowSectionType;
  index: string;
  commonStyles: any;
}

const SectionRow: React.FC<props> = ({ row, index, commonStyles }) => {
  return (
    <TableRow key={index}>
      <TableCell
        align="left"
        sx={{
          ...commonStyles.cellBody,
          fontWeight: 700,
          paddingLeft: 0,
          borderBottom: '1px solid #737373',
        }}
      >
        {row.label}
      </TableCell>
    </TableRow>
  );
};
export default SectionRow;
